/* pdp-quiz.js — PDP-isolated Find Your Shade quiz + education dialog helpers.
   Do not edit lp-quiz.js. Emits `bbe:pdp-shade-quiz:select` only on confirm. */
(function () {
  'use strict';

  function quizWinnerFromTally(T) {
    var keys = ['light', 'medium', 'dark'];
    keys.sort(function (a, b) {
      if (T[b] !== T[a]) return T[b] - T[a];
      var pref = { medium: 0, light: 1, dark: 2 };
      return pref[a] - pref[b];
    });
    return keys[0];
  }

  function clampQuizWinnerToCeiling(rawWinner, ceilingRaw) {
    var c = String(ceilingRaw || '').trim().toLowerCase();
    var w = String(rawWinner || '').trim().toLowerCase();
    if (!w) return 'medium';
    if (c === 'medium' && w === 'dark') return 'medium';
    if (c === 'light' && (w === 'dark' || w === 'medium')) return 'light';
    return w;
  }

  function slugifyShade(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s*—\s*sold out\s*$/, '')
      .trim()
      .replace(/\s+/g, '-');
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function emitShadeQuizSelect(lb, winner, v) {
    var titleEl = lb.querySelector('#pdp-shade-quiz-result-title');
    var title = (v && v.title) || (titleEl && String(titleEl.textContent || '').trim()) || winner;
    var detail = {
      tier: winner,
      title: title,
      shade: (v && v.shade) || slugifyShade(title) || winner,
    };
    document.dispatchEvent(new CustomEvent('bbe:pdp-shade-quiz:select', { detail: detail, bubbles: true }));
    if (window.BBEPdpShadeQuiz && typeof window.BBEPdpShadeQuiz.onSelect === 'function') {
      try {
        window.BBEPdpShadeQuiz.onSelect(detail);
      } catch (e) {}
    }
    return detail;
  }

  function getFocusable(root) {
    return Array.prototype.slice
      .call(
        root.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [role="radio"], [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
  }

  function initShadeQuizLightboxForLb(lb) {
    if (!lb || lb.dataset.pdpShadeQuizBound === '1') return;
    lb.dataset.pdpShadeQuizBound = '1';

    var root = lb.closest('[data-pdp-shade-quiz-root]') || lb.parentElement || document;
    var sheet = lb.querySelector('.pdp-quiz-lb__sheet');
    var backBtn = lb.querySelector('#pdp-shade-quiz-lb-back');
    var closeX = lb.querySelector('#pdp-shade-quiz-lb-x');
    var progFill = lb.querySelector('#pdp-shade-quiz-lb-progress-fill');
    var progLabel = lb.querySelector('#pdp-shade-quiz-lb-progress-label');
    var stepEls = lb.querySelectorAll('[data-lb-step]');
    var cfg = {};
    try {
      var cfgEl =
        (root.querySelector && root.querySelector('#pdp-shade-quiz-config')) ||
        document.getElementById('pdp-shade-quiz-config');
      if (cfgEl && cfgEl.textContent) cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      cfg = {};
    }

    var fieldByStep = [null, 'pdp_sq_burn', 'pdp_sq_freckle', 'pdp_sq_tone', 'pdp_sq_eyes', 'pdp_sq_hair'];
    var FIRST_STEP = 1; /* skip intro — open on question 1 */
    var QUESTIONS_START = 1;
    var step = FIRST_STEP;
    var lastFocus = null;
    var suppressAutoAdvance = false;

    function computeWinner() {
      var T = { light: 0, medium: 0, dark: 0 };
      ['pdp_sq_burn', 'pdp_sq_freckle', 'pdp_sq_tone', 'pdp_sq_eyes', 'pdp_sq_hair'].forEach(function (n) {
        var i = lb.querySelector('input[name="' + n + '"]:checked');
        if (i && T[i.value] !== undefined) T[i.value] += 1;
      });
      var winner = clampQuizWinnerToCeiling(quizWinnerFromTally(T), cfg.quizShadeCeiling);
      var pool = (cfg.variants || []).filter(function (x) {
        return x.tier === winner;
      });
      /* No Dark variant on product — map Dark quiz outcome to Medium */
      if (!pool.length && winner === 'dark') {
        winner = 'medium';
        pool = (cfg.variants || []).filter(function (x) {
          return x.tier === 'medium';
        });
      }
      var v = pool.find(function (x) {
        return x.img;
      }) || pool[0];
      return { winner: winner, v: v };
    }

    function applyResult() {
      var computed = computeWinner();
      var winner = computed.winner;
      var v = computed.v;
      var res = cfg.results && cfg.results[winner];
      var schemaHero = res && res.hero_image;
      var optionHero = cfg.option_images && cfg.option_images[winner];
      var heroUrl =
        (schemaHero && String(schemaHero).trim() !== '' && schemaHero) ||
        (v && v.img && String(v.img).trim() !== '' && v.img) ||
        (optionHero && String(optionHero).trim() !== '' && optionHero) ||
        '';

      var titleEl = lb.querySelector('#pdp-shade-quiz-result-title');
      var img = lb.querySelector('#pdp-shade-quiz-result-img');
      var imgWrap = lb.querySelector('#pdp-shade-quiz-result-img-wrap');
      var copyEl = lb.querySelector('#pdp-shade-quiz-result-copy');
      if (titleEl) titleEl.textContent = (v && v.title) || winner;
      if (img) {
        if (heroUrl) {
          img.src = heroUrl;
          img.alt = (v && v.title) || '';
          img.hidden = false;
          if (imgWrap) imgWrap.hidden = false;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
          if (imgWrap) imgWrap.hidden = true;
        }
      }
      if (copyEl) copyEl.innerHTML = (res && res.copy) || '';

      var ba = (cfg.ba && cfg.ba[winner]) || {};
      var bb = lb.querySelector('#pdp-shade-quiz-ba-before');
      var baft = lb.querySelector('#pdp-shade-quiz-ba-after');
      var baBox = lb.querySelector('#pdp-shade-quiz-result-ba');
      if (bb) {
        if (ba.before) {
          bb.src = ba.before;
          bb.closest('figure').style.display = '';
        } else {
          bb.removeAttribute('src');
          bb.closest('figure').style.display = 'none';
        }
      }
      if (baft) {
        if (ba.after) {
          baft.src = ba.after;
          baft.closest('figure').style.display = '';
        } else {
          baft.removeAttribute('src');
          baft.closest('figure').style.display = 'none';
        }
      }
      if (baBox) baBox.style.display = ba.before || ba.after ? 'grid' : 'none';
      /* Preview only — do not emit until SELECT THIS SHADE */
    }

    function setProgress() {
      if (progFill) {
        var pct = step >= 1 && step <= 5 ? Math.round((step / 6) * 100) : step === 6 ? 100 : 0;
        progFill.style.width = pct + '%';
      }
      if (!progLabel) return;
      if (step >= 1 && step <= 5) progLabel.textContent = 'Question ' + step + ' of 5';
      else progLabel.textContent = '';
    }

    function setStep(n) {
      step = n;
      if (sheet) {
        sheet.scrollTop = 0;
        sheet.classList.toggle('pdp-quiz-lb__sheet--result', step === 6);
      }
      stepEls.forEach(function (el) {
        var on = parseInt(el.getAttribute('data-lb-step'), 10) === step;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
      if (backBtn) backBtn.hidden = step <= FIRST_STEP || step === 6;
      setProgress();
      if (step === 6) {
        var resEl = lb.querySelector('[data-lb-step="6"]');
        if (resEl) focusEl(resEl);
      } else if (step === FIRST_STEP) {
        var firstOpt = lb.querySelector('[data-lb-step="1"] .pdp-quiz-lb__opt input');
        if (firstOpt) focusEl(firstOpt);
        else if (closeX) focusEl(closeX);
      }
    }

    function resetQuiz() {
      suppressAutoAdvance = true;
      lb.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.checked = false;
      });
      step = FIRST_STEP;
      setStep(FIRST_STEP);
      suppressAutoAdvance = false;
    }

    function validateCurrent() {
      if (step === 6) return true;
      var name = fieldByStep[step];
      if (!name) return true;
      return !!lb.querySelector('input[name="' + name + '"]:checked');
    }

    function advanceAfterAnswerIfCurrent() {
      if (suppressAutoAdvance || lb.hidden) return;
      if (step < QUESTIONS_START || step > 5) return;
      if (!validateCurrent()) return;
      if (step === 5) {
        applyResult();
        setStep(6);
        return;
      }
      setStep(step + 1);
    }

    function openLb() {
      lastFocus = document.activeElement;
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pdp-shade-quiz-lb-open');
      resetQuiz();
      var placeQuizFocus = function () {
        var firstOpt = lb.querySelector('[data-lb-step="1"].is-active .pdp-quiz-lb__opt input');
        if (firstOpt) focusEl(firstOpt);
        else if (closeX) focusEl(closeX);
      };
      requestAnimationFrame(function () {
        placeQuizFocus();
        setTimeout(placeQuizFocus, 50);
      });
    }
    lb.__pdpOpenShadeQuiz = openLb;

    function closeLb() {
      lb.hidden = true;
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pdp-shade-quiz-lb-open');
      if (lastFocus && typeof lastFocus.focus === 'function') focusEl(lastFocus);
    }

    lb.querySelectorAll('[data-pdp-shade-quiz-lb-close]').forEach(function (el) {
      el.addEventListener('click', closeLb);
    });
    if (closeX) closeX.addEventListener('click', closeLb);
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (step > FIRST_STEP) setStep(step - 1);
      });
    }
    lb.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('.pdp-quiz-lb__opt') : null;
      if (!opt || !lb.contains(opt) || suppressAutoAdvance) return;
      if (step < QUESTIONS_START || step > 5) return;
      var radio = opt.querySelector('input[type="radio"]');
      if (!radio || radio.name !== fieldByStep[step]) return;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      advanceAfterAnswerIfCurrent();
    });

    lb.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !lb.contains(t) || suppressAutoAdvance) return;
      if (step < QUESTIONS_START || step > 5) return;
      if (t.name !== fieldByStep[step]) return;
      advanceAfterAnswerIfCurrent();
    });

    var retryBtn = lb.querySelector('.js-pdp-shade-quiz-retry');
    if (retryBtn) retryBtn.addEventListener('click', resetQuiz);

    lb.addEventListener('click', function (e) {
      var sel = e.target && e.target.closest ? e.target.closest('.js-pdp-shade-quiz-select-shade') : null;
      if (!sel || !lb.contains(sel) || step !== 6) return;
      e.preventDefault();
      var computed = computeWinner();
      applyResult();
      emitShadeQuizSelect(lb, computed.winner, computed.v);
      closeLb();
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeLb();
        return;
      }
      if (e.key === 'Tab' && sheet) {
        var f = getFocusable(sheet);
        if (!f.length) return;
        var first = f[0],
          last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (!sheet.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  function initEducationDialog() {
    var dialog = document.getElementById('shade_picker_modal');
    if (!dialog || dialog.dataset.pdpFinderBound === '1') return;
    dialog.dataset.pdpFinderBound = '1';
    var lastFocus = null;

    function openEducation() {
      lastFocus = document.activeElement;
      if (typeof dialog.showModal === 'function' && !dialog.open) {
        try {
          dialog.showModal();
        } catch (err) {
          dialog.setAttribute('open', '');
        }
      }
      document.documentElement.classList.add('pdp-shade-finder-open');
      var placeFocus = function () {
        if (!dialog.open) return false;
        if (dialog.contains(document.activeElement) && document.activeElement !== document.body) return true;
        var closeBtn = dialog.querySelector('.pdp-shade-finder__close');
        focusEl(closeBtn);
        return dialog.contains(document.activeElement);
      };
      var attempts = 0;
      var tick = function () {
        if (placeFocus() || attempts++ > 12) return;
        setTimeout(tick, 40);
      };
      requestAnimationFrame(tick);
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('pdp-shade-finder-open');
      if (lastFocus && typeof lastFocus.focus === 'function') focusEl(lastFocus);
    });

    document.addEventListener(
      'click',
      function (e) {
        var opener = e.target && e.target.closest && e.target.closest('.js-pdp-shade-finder-open, #open-shade-finder');
        if (!opener) return;
        e.preventDefault();
        openEducation();
      },
      true
    );

    dialog.__pdpOpenShadeFinder = openEducation;
  }

  var openBound = false;
  function bindOpenOnce() {
    if (openBound) return;
    openBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var opener = e.target.closest && e.target.closest('.js-pdp-shade-quiz-open');
        if (!opener) return;
        var mod = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
        var fb = (opener.getAttribute('data-pdp-shade-quiz-fallback-url') || '').trim();
        var scope = opener.closest('[data-pdp-shade-quiz-root]') || document;
        var lbEl = scope.querySelector('#pdp-shade-quiz-lb') || document.getElementById('pdp-shade-quiz-lb');

        var edu = document.getElementById('shade_picker_modal');
        if (edu && edu.open && typeof edu.close === 'function') {
          try {
            edu.close();
          } catch (err) {}
        }

        if (lbEl && typeof lbEl.__pdpOpenShadeQuiz === 'function') {
          if (mod) {
            if (fb) {
              e.preventDefault();
              window.open(fb, '_blank', 'noopener,noreferrer');
            }
            return;
          }
          e.preventDefault();
          lbEl.__pdpOpenShadeQuiz();
          return;
        }
        if (!mod && fb) {
          e.preventDefault();
          window.location.assign(fb);
        }
      },
      true
    );
  }

  function init() {
    bindOpenOnce();
    initEducationDialog();
    document.querySelectorAll('#pdp-shade-quiz-lb').forEach(initShadeQuizLightboxForLb);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

(function () {
  'use strict';
  /* Apply quiz result to PDP shade radios only after SELECT THIS SHADE */
  document.addEventListener('bbe:pdp-shade-quiz:select', function (e) {
    var detail = (e && e.detail) || {};
    var tier = String(detail.tier || '').toLowerCase();
    var title = String(detail.title || '').trim();
    var picker = document.querySelector('variant-picker');
    if (!picker) return;

    var optionIndex = 0;
    var shadeItems = picker.querySelector('#shade-items');
    if (shadeItems && shadeItems.dataset.optionIndex != null) {
      optionIndex = Number(shadeItems.dataset.optionIndex);
    }

    var radios = picker.querySelectorAll(
      'input[type="radio"][name="shade"][data-option-index="' + optionIndex + '"]'
    );
    function findRadioForTier(t) {
      var hit = null;
      radios.forEach(function (r) {
        var v = String(r.value || '');
        var vl = v.toLowerCase();
        if (title && vl === title.toLowerCase()) hit = r;
        else if (!hit && t === 'light' && (vl === 'light' || vl.indexOf('fair') !== -1 || vl.indexOf('light') !== -1))
          hit = r;
        else if (!hit && t === 'medium' && (vl === 'medium' || vl.indexOf('medium') !== -1)) hit = r;
        else if (!hit && t === 'dark' && (vl === 'dark' || vl.indexOf('dark') !== -1 || vl.indexOf('extra') !== -1))
          hit = r;
      });
      return hit;
    }

    var match = findRadioForTier(tier);
    /* Dark quiz path on Light/Medium-only SKU — select Medium variant */
    if (!match && tier === 'dark') match = findRadioForTier('medium');
    if (!match) return;

    if (typeof picker.applyModalSelection === 'function') {
      picker.applyModalSelection(match.value, optionIndex);
    } else if (!match.checked) {
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }
  });
})();
